import { InputControllerBase, type InputListenerEntry } from './InputControllerBase';

export interface CanvasInputHandlers {
  pointerDown: (e: PointerEvent) => void;
  pointerMove: (e: PointerEvent) => void;
  pointerUp: (e: PointerEvent) => void;
  pointerLeave: (e: PointerEvent) => void;
  wheel: (e: WheelEvent) => void;
  keyDown: (e: KeyboardEvent) => void;
  keyUp: (e: KeyboardEvent) => void;
  pointerCancel?: (e: PointerEvent) => void;
  doubleClick?: (e: MouseEvent) => void;
  click?: (e: MouseEvent) => void;
  contextMenu?: (e: MouseEvent) => void;
}

export class CanvasInputController extends InputControllerBase {
  protected readonly listeners: InputListenerEntry[];

  constructor(canvas: HTMLCanvasElement, handlers: CanvasInputHandlers) {
    super();
    this.listeners = [
      { target: canvas, type: 'pointerdown', handler: handlers.pointerDown as EventListener },
      { target: canvas, type: 'pointermove', handler: handlers.pointerMove as EventListener },
      { target: canvas, type: 'pointerup', handler: handlers.pointerUp as EventListener },
      { target: canvas, type: 'pointerleave', handler: handlers.pointerLeave as EventListener },
    ];

    if (handlers.pointerCancel) {
      this.listeners.push({
        target: canvas,
        type: 'pointercancel',
        handler: handlers.pointerCancel as EventListener,
      });
    }

    if (handlers.doubleClick) {
      this.listeners.push({
        target: canvas,
        type: 'dblclick',
        handler: handlers.doubleClick as EventListener,
      });
    }

    if (handlers.click) {
      this.listeners.push({
        target: canvas,
        type: 'click',
        handler: handlers.click as EventListener,
      });
    }

    if (handlers.contextMenu) {
      this.listeners.push({
        target: canvas,
        type: 'contextmenu',
        handler: handlers.contextMenu as EventListener,
      });
    }

    this.listeners.push(
      {
        target: canvas,
        type: 'wheel',
        handler: handlers.wheel as EventListener,
        options: { passive: false },
      },
      { target: document, type: 'keydown', handler: handlers.keyDown as EventListener },
      { target: document, type: 'keyup', handler: handlers.keyUp as EventListener }
    );
  }
}
